module.exports = __webpack_public_path__ + "static/media/SWSCRC6-43.3f105c7d.mp3";